/**
 * LCP Image Optimization for Product Pages
 *
 * Automatically adds fetchpriority="high" and ensures eager loading
 * for the first product image (LCP element) on product detail pages.
 *
 * This addresses Google PageSpeed Insights recommendations:
 * - Add fetchpriority:high to LCP image
 * - Ensure LCP image doesn't lazy load
 * - Ensure image is discoverable in initial HTML
 */

(function() {
  'use strict';

  // Only run on product pages
  if (window.template !== 'product' && !document.body.classList.contains('template-product')) {
    return;
  }

  /**
   * Optimize the first product image for LCP
   */
  function optimizeLCPImage() {
    // Find the first product image (the LCP element)
    // Look for the lead image in product-images component
    const productImagesContainer = document.querySelector('.product-images');
    if (!productImagesContainer) {
      console.log('ℹ️ No product images container found');
      return;
    }

    // Find the first image with lead class (main product image)
    const firstImage = productImagesContainer.querySelector('.product-images__image--lead img, .product-images__item:first-child img');

    if (!firstImage) {
      console.log('ℹ️ No product LCP image found');
      return;
    }

    // Add fetchpriority="high" to prioritize loading
    if (!firstImage.hasAttribute('fetchpriority')) {
      firstImage.setAttribute('fetchpriority', 'high');
      console.log('✅ Added fetchpriority="high" to LCP product image');
    }

    // Ensure eager loading (no lazy loading for LCP)
    if (firstImage.hasAttribute('loading')) {
      firstImage.setAttribute('loading', 'eager');
      console.log('✅ Changed loading to "eager" for LCP product image');
    } else {
      firstImage.setAttribute('loading', 'eager');
      console.log('✅ Set loading="eager" for LCP product image');
    }

    // Remove any lazy loading classes
    if (firstImage.classList.contains('lazyloaded') || firstImage.classList.contains('lazy')) {
      firstImage.classList.remove('lazyloaded', 'lazy');
      console.log('✅ Removed lazy loading classes from LCP product image');
    }

    // Mark performance metric
    if (typeof performance !== 'undefined' && performance.mark) {
      performance.mark('lcp-image-optimized');
    }

    return true;
  }

  /**
   * Initialize optimization
   * Try immediately when DOM is ready, also use MutationObserver
   * to catch when Vue component renders
   */
  function init() {
    // Try immediately
    if (optimizeLCPImage()) {
      return;
    }

    // If not found, wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        if (optimizeLCPImage()) {
          return;
        }

        // If still not found, use MutationObserver to wait for Vue component
        const observer = new MutationObserver(function(mutations, obs) {
          if (optimizeLCPImage()) {
            obs.disconnect();
            console.log('✅ LCP image optimization completed via MutationObserver');
          }
        });

        // Start observing the product detail section
        const productDetail = document.querySelector('.product-detail');
        if (productDetail) {
          observer.observe(productDetail, {
            childList: true,
            subtree: true
          });

          // Stop observing after 5 seconds to avoid unnecessary overhead
          setTimeout(function() {
            observer.disconnect();
          }, 5000);
        }
      });
    } else {
      // DOM already ready, try with MutationObserver
      const observer = new MutationObserver(function(mutations, obs) {
        if (optimizeLCPImage()) {
          obs.disconnect();
          console.log('✅ LCP image optimization completed via MutationObserver');
        }
      });

      const productDetail = document.querySelector('.product-detail');
      if (productDetail) {
        observer.observe(productDetail, {
          childList: true,
          subtree: true
        });

        setTimeout(function() {
          observer.disconnect();
        }, 5000);
      }
    }
  }

  // Start optimization
  init();
})();
